export default function Acervo() {
  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-7xl items-center justify-center px-4 py-16">
      <h1 className="text-3xl font-semibold text-gray-700">Em desenvolvimento</h1>
    </div>
  );
}

